import { Navigate } from 'react-router-dom';
import { getparceiro } from 'functions/gettabconfig';

function PrivateParceiro(props){
    const logado = getparceiro(); 
    // console.log('parceiro logado', logado)   
    return logado ? props.children : <Navigate to='/parceiro/login' />;
}

export default PrivateParceiro;